import { useEffect, useRef } from 'react';
// Calls onDismiss when a press lands outside every given view. Hover-only
// pop-ups have no backdrop to tap, so touch users need this to close them.
const useDismissOnOutsidePress = (enabled, refs, onDismiss) => {
    // Kept in refs so the listener isn't re-attached on every render
    const refsRef = useRef(refs);
    const onDismissRef = useRef(onDismiss);
    useEffect(() => {
        refsRef.current = refs;
        onDismissRef.current = onDismiss;
    });
    useEffect(() => {
        if (!enabled)
            return undefined;
        const doc = window.document;
        if (!doc)
            return undefined;
        const onPointerDown = (e) => {
            const isInside = refsRef.current.some((ref) => {
                const node = ref.current;
                return typeof node?.contains === 'function' && node.contains(e.target);
            });
            if (!isInside) {
                onDismissRef.current();
            }
        };
        doc.addEventListener('pointerdown', onPointerDown, true);
        return () => doc.removeEventListener('pointerdown', onPointerDown, true);
    }, [enabled]);
};
export default useDismissOnOutsidePress;
